import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MainEvolutionarySection.module.scss';

export const MainEvolutionarySection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles['section-open']} id="about">
      <div className={styles['container']}>
        <div className={styles['section-head']}>
          <h2 className={styles['section-title']}>
            {t('landing.mainEvolutionary.title', 'Otra forma de comprender la salud')}
          </h2>
          <p className={styles['section-copy']}>
            {t('landing.mainEvolutionary.copy', 'Bodhiwell nace para tender puentes en un contexto donde la salud muchas veces sigue viviéndose de forma fragmentada.')}
          </p>
        </div>

        <div className={styles['grid-3']}>
          <article className={styles['value-item']}>
            <h3>{t('landing.mainEvolutionary.cards.conexion.title', 'Conexión')}</h3>
            <p>{t('landing.mainEvolutionary.cards.conexion.desc', 'Acercamos personas, profesionales y perspectivas que hoy suelen encontrarse dispersas.')}</p>
          </article>
          <article className={styles['value-item']}>
            <h3>{t('landing.mainEvolutionary.cards.integracion.title', 'Integración')}</h3>
            <p>{t('landing.mainEvolutionary.cards.integracion.desc', 'Entendemos la integración no como una simple convivencia entre disciplinas, sino como la posibilidad real de interacción entre miradas distintas.')}</p>
          </article>
          <article className={styles['value-item']}>
            <h3>{t('landing.mainEvolutionary.cards.comunidad.title', 'Comunidad')}</h3>
            <p>{t('landing.mainEvolutionary.cards.comunidad.desc', 'Construimos un espacio donde el intercambio, la colaboración y el contenido de valor puedan abrir nuevas posibilidades para comprender y acompañar la salud.')}</p>
          </article>
        </div>

        <div className={styles['section-footer']}>
          <div className={styles['divider']}></div>
          <p>
            {t('landing.mainEvolutionary.footer', 'Una plataforma y una comunidad para vivir la salud de una manera más amplia, consciente e integradora.')}
          </p>
          <div className={styles['divider']}></div>
        </div>
      </div>
    </section>
  );
};
